export default from './AnimatedLogo'